type ErrorComponentProps = {
  [prop: string]: unknown;
};

const CustomError = (({ error }: ErrorComponentProps) => {
  const devMode = process.env.NODE_ENV === "development";
  if (devMode) {
    console.warn("Render error:", error);
  }

  return <></>;
}) satisfies React.FC<ErrorComponentProps>;

export default CustomError;
